import React from 'react'
import Header1 from '../component/Header1'
import Legend from '../component/Legend'
import Credits from '../component/Credits'
import { makeStyles } from '@material-ui/core/styles'
import Foto3 from '../images/informe1foto3.jpg'
import Foto2 from '../images/informe1foto2.jpg'
import Foto4 from '../images/informe1foto4.jpg'
import Foto1 from '../images/informe1foto1.jpg'
import Infografia from '../images/infografia_bofedales.jpg'
import { Helmet } from 'react-helmet'

const useStyles = makeStyles(theme => ({
  text: {
    maxWidth: 800,
    margin: '1em auto',
    fontSize: 16,
    fontFamily: 'Roboto Slab',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 20,
      paddingRight: 20
    }
  },
  content: {
    position: 'relative',
    background: '#fff',
    paddingTop: '4em',
    paddingBottom: '4em'
  },
  map: {
    border: 0,
    width: '100%',
    height: '50vh'
  },
  latest: {
    width: '100%',
    height: 800,
    [theme.breakpoints.down('md')]: {
      height: 420
    },
    [theme.breakpoints.down('sm')]: {
      height: 220
    }
  }
}))

const Informe1 = () => {
  const classes = useStyles()
  const width = '100%'
  const bajada =
    'Más de 80 millones de soles tiene Sedapal para invertir en proyectos ecosistémicos. El fondo proviene de un pago que efectúan los usuarios de Lima en los recibos de agua. En el 2020 inician la ejecución de un primer proyecto para revivir los bofedales de Milloc. Es el primer paso para recuperar una de nuestras fuentes de agua.'

  return (
    <div>
      <Helmet
      title="La resurrección de los bofedales que necesita Lima"
      meta={[
        { property: "og:title", content: "La resurrección de los bofedales que necesita Lima", dataReactHelmet: true },
        { property: "description", content: "Más de 80 millones de soles tiene Sedapal para invertir en proyectos ecosistémicos.", dataReactHelmet: true  }
        // Any other meta tags go here as objects or you can just add children directly inside this component.
      ]}
    />
      <Header1
        bajada={bajada}
        title={'La resurrección de los bofedales que necesita Lima'}
        legend="Foto: Bofedales de Milloc en las alturas de la sierra de Lima"
        image={Foto1}
      />
      <div className={classes.content}>
        <div className={classes.text}>
          <Credits>
            <p>Texto: Marjorie Ramos Poma</p>
            <p>Fotos: Wilber Huacasi Huamán</p>
          </Credits>
          <br></br>
          <p>
            “Un día atrapamos a los camioneros con las manos en la masa.
            Denunciamos como directiva y fuimos al puesto policial en Matucana,
            de ahí los ‘champeros’ solucionaron el asunto y los soltaron y se
            fueron”, cuenta indignado Hugo Cayamo, secretario de la comunidad
            campesina Santiago de Carampoma.
          </p>
          <p>
            El comunero recuerda estos sucesos ocurridos hace dos años. Desde
            entonces no ha pasado nada. No sería la primera vez que sucede algo
            así. Su comunidad, ubicada en el distrito de Carampoma, provincia
            limeña de Huarochirí, ha enfrentado en más de una ocasión a los
            ‘champeros’ que extraen cojines de turba de los bofedales de Milloc
            y se los llevan en camiones por la noche de forma ilegal.{' '}
          </p>
          <br></br>
          <img
            src={Foto3}
            alt="La resurrección de los bofedales que necesita Lima"
            style={{ maxWidth: '100%' }}
          />
          <Legend>
            Hugo Cayamo, secretario de la comunidad campesina Santiago de
            Carampoma.
          </Legend>
          <br></br>
          <p>
            La República llegó hasta esta zona, situada a una altitud de 4329
            metros. El panorama, rodeado por montañas, parece abrazar con recelo
            a la laguna de Milloc y tras de sí a los últimos bofedales vivos que
            la acompañan. Los comuneros que vienen a pastear a su ganado por
            estos lares saben que cada día la situación está peor. No solo se
            están quedando sin pasto, mientras sus animales se enferman, sino
            que cada vez ven más reducido un elemento vital: el agua.
          </p>
          <p>
            “Los bofedales almacenan el agua, entonces ahí nace y luego viene
            aquí al pueblo”, explica Cayamo, quien a diario tiene que recorrer
            30 minutos para llegar a estos humedales y proveer de alimento a su
            ganado. Así, en pocas palabras, explica que no es casualidad que,
            tras la degradación de estos ecosistemas, el agua esté llegando en
            menor cantidad a Carampoma.
          </p>
          <p>
            Nosotros tuvimos que recorrer cerca de cuatro horas desde Lima para
            llegar a la misma conclusión: si los ecosistemas que nos proveen el
            servicio hídrico siguen siendo dañados y nadie hace mayores
            esfuerzos por recuperarlos, poco a poco se verá afectada la
            seguridad hídrica de toda Lima metropolitana.
          </p>
          <br></br>
          <br></br>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1000914.0510165615!2d-77.2292383!3d-11.4928688!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x910601607d01ce77%3A0xc1e5533a685b1354!2sCarampoma%2015525!5e0!3m2!1ses!2spe!4v1576341070069!5m2!1ses!2spe"
          frameBorder="0"
          className={classes.map}
          allowFullScreen=""
          title="Map"
        ></iframe>
        <div className={classes.text}>
          <br></br>
          <h2>Una secuela de impactos</h2>
          <p>
            Entre Lima y Carampoma hay más de 90 kilómetros, y un accidentado
            camino por el cual se puede observar las gigantescas represas de
            cemento que guían el agua hacia la capital. Aquí se encuentran los
            ecosistemas de cuenca alta que captan y almacenan el agua que
            consume la mayoría de limeños.
          </p>
          <p>
            En esta red de lagunas se encuentra Milloc. “Esta laguna es
            importante porque es donde se vierte el agua del túnel trasandino y
            la que trae agua desde la cuenca alta del río Mantaro, literalmente
            la que alimenta a Lima, porque casi el 60% del agua que alimenta a
            Lima viene de Junín. El Rímac, como cuenca propia, solo aporta el
            15%”, explica la bióloga Susana Manrique, de Condesan y el proyecto
            Infraestructura Natural para la Seguridad Hídrica.
          </p>
          <p>
            Por su parte, los bofedales, definidos como un tipo de humedal
            altoandino que presenta vegetación hidromórfica y que acumula turba
            –suelo orgánico con alto contenido de carbono–, funcionan como una
            especie de esponja que toma el agua y empieza a soltarla de manera
            más dosificada durante las épocas de estiaje o sequías. Al igual que
            la mayoría de los comuneros, Susana señala que la extracción de la
            ‘champa’ o turba por parte de foráneos es uno de los principales
            impactos que han sufrido los bofedales. Mientras recorremos los
            pastizales secos señala los enormes huecos rectangulares que han
            sido despojados de su habitad para ser vendidos en forma clandestina
            como bono orgánico en los viveros de Lima.
          </p>
          <p>
            Los ‘champeros’ no son el único problema. “Esta zona se ha visto
            afectada por la carretera que une a los distritos de Huarochirí,
            como Carampoma, con Junín. El agua que infiltra a la ladera ya no
            llega al bofedal como lo hacía de forma natural”.{' '}
          </p>
          <p>
            Otra intervención que ha detenido el flujo de agua tiene que ver con
            la laguna Canchis, la cual ha sido interrumpida dos veces por la
            carretera. “La quebrada que llegaba naturalmente a esta zona y los
            abastecía con el recurso hídrico ha sido desviada hacia el túnel
            trasandino, entonces ya no llega a estos bofedales, ya no los puede
            alimentar”.
          </p>
          <p>
            Por otro lado, el sobrepastoreo, debido a un mal sistema de rotación
            de ganado, ha ido reduciendo las especies de plantas llamadas
            distichia muscoide, las cuales contribuyen a la generación de turba.
          </p>
          <br></br>
          <br></br>
        </div>
        <iframe
          frameBorder="0"
          title="Compare"
          className={classes.latest}
          width={width}
          src="https://cdn.knightlab.com/libs/juxtapose/latest/embed/index.html?uid=a542709e-1e95-11ea-b9b8-0edaf8f81e27"
        ></iframe>
        <div className={classes.text}>
          <br></br>
          <h2>El primer proyecto</h2>
          <p>
            Ante este panorama, una nueva propuesta ha llamado la atención de
            las instituciones que administran el agua en nuestro país: los
            Mecanismos de Retribución por Servicios Ecosistémicos (MERESE)
            hídricos, que en pocas palabras son pactos por el agua. SEDAPAL ya
            se ha alineado a esta normativa e incluso cuenta con un fondo
            intangible de más de S/ 80 millones, recaudado a todos los limeños,
            a través de la tarifa del 1% que cobra en el recibo mensual.
          </p>
          <p>
            La urgente recuperación de los bofedales de Milloc es el primer
            proyecto de infraestructura natural que ejecutará SEDAPAL, con parte
            de esos fondos. Solo este proyecto costará un aproximado de S/ 2.5
            millones. La ejecución física debe iniciar en el primer trimestre
            del 2020.
          </p>
          <p>
            Susan Manrique, quien además trabaja de manera conjunta con
            SEDAPAL, advierte que Milloc está formulado desde el 2016 y hay la
            necesidad de que el proyecto salga lo más pronto posible.
          </p>
          <p>
            “El área de intervención directa son 98 hectáreas, las cuales
            conforman el cerco perimétrico que vamos a poner para evitar que se
            vuelva a impactar con sobrepastoreo y que vuelvan a entrar los
            champeros”, explica Manrique. Afirma que la comunidad de Carampoma
            recibirá capacitaciones para tener herramientas que le permitan
            hacer un mejor uso de sus ecosistemas, pero también para que
            obtengan un beneficio económico.
          </p>
          <p>
            Sobre este punto, Hugo Camayo sostiene que los vecinos de la
            comunidad ya han sostenido reuniones con SEDAPAL y que “están de
            acuerdo con que los ayuden a cuidar su sistema natural”.{' '}
          </p>
          <p>
            Por otro lado, se ha propuesto un sistema de riego que abastezca
            estos bofedales secos de agua. “Vamos a recuperar la cobertura
            vegetal a través de una técnica llamada trasplantes de tepes, que
            consiste en sacar una pequeña porción de bofedal de un espacio y
            trasladarlo a Milloc, pero teniendo en consideración la capacidad
            del espacio sano de recuperarse”, asegura.
          </p>
          <br></br>
          <img
            src={Infografia}
            alt="La resurrección de los bofedales que necesita Lima"
            style={{ maxWidth: '100%' }}
          />
          <br></br>
          <br></br>
        </div>
        <img
          src={Foto2}
          alt="La resurrección de los bofedales que necesita Lima"
          style={{ maxWidth: '100%' }}
        />
        <Legend>
          Bofedales de Canchis, un modelo de cómo debería funcionar esta
          infraestructura natural.
        </Legend>
        <div className={classes.text}>
          <br></br>
          <h2>La agenda pendiente</h2>
          <p>
            Alonzo Zapata, director del Equipo de Gestión Ambiental y Servicios
            Ecosistémicos (EGASE) de SEDAPAL, apunta que estas “intervenciones
            son bastante sencillas pero efectivas en términos de recuperar el
            servicio ecosistémico”. Sin embargo, no es el único proyecto que
            está en agenda.
          </p>
          <p>
            “Tenemos 32 proyectos en el Plan Maestro Optimizado (PMO) y queremos
            extenderlo hasta 100 para incluirlo en este plan que va del 2020 al
            2025. Ese es nuestro horizonte de proyectos”, asegura Zapata.
          </p>
          <p>
            Debido a la creciente demanda de agua de Lima calificada como la
            segunda ciudad más grande del mundo ubicada en un desierto, después
            de El Cairo, las cuencas del Chillón, Rímac, Lurín y Mantaro son
            insuficientes para abastecer a una ciudad con cerca de 10 millones
            de habitantes.{' '}
          </p>
          <p>
            El ente regulador del agua potable, SUNASS, estableció desde el 2015
            el cobro de una tarifa mensual a los ciudadanos limeños para la
            conservación y restauración de las fuentes de agua en las cuencas
            altas. A pesar de que han pasado cuatro años aún no se ha ejecutado
            el monto recaudado, que ya tiene una proyección de 90 millones para
            el 2020.
          </p>
          <br></br>
          <img
            src={Foto4}
            alt="La resurrección de los bofedales que necesita Lima"
            style={{ maxWidth: '100%' }}
          />
          <Legend>
            Alonzo Zapata, director de EGASE - SEDAPAL.
          </Legend>
          <br></br>
          <p>
            Sobre ello, Zapata alega SEDAPAL “no tiene el expertise para hacer
            proyectos de infraestructura verde porque siempre se ha dedicado a
            infraestructura gris”, pero vienen trabajando con ONG e
            instituciones que tienen experiencia en el tema.{' '}
          </p>
          <p>
            Por otro lado, los MERESE tienen como una de sus características a
            las plataformas de buena gobernanza, que son espacios de
            participación con los actores involucrados y fundamentalmente las
            comunidades campesinas. Así, por ejemplo, Zapata afirma que el
            gobierno regional de Junín ha mostrado su interés en las
            intervenciones que se están planteando realizar en la cuenca del
            Mantaro.
          </p>
          <p>
            “Vamos a visibilizar a las comunidades que están en la parte media y
            la parte alta, quienes siempre han estado ahí haciendo actividades
            de conservación, cuidando Percy Salome el agua para la gente que
            está en la parte baja. La idea es retribuir, mirarlos hacia ellos”,
            sentencia.
          </p>
          <br></br>
          
          <br></br>
        </div>
        <div itemScope itemType="https://schema.org/VideoObject">
            <meta
              itemProp="uploadDate"
              content="Tue Dec 10 2019 21:59:38 GMT-0500 (hora estándar de Perú)"
            />
            <meta
              itemProp="name"
              content="La resurrección de los bofedales que necesita Lima"
            />
            <meta
              itemProp="description"
              content="Más de 80 millones de soles sin gastar. El fondo es pagado por todos los usuarios de Lima en sus recibos de agua por concepto de mecanismos de retribución por servicios ecosistémicos. FUENTE: La República"
            />
            <meta itemProp="duration" content="PT4M40.35S" />
            <meta
              itemProp="thumbnailUrl"
              content="https://content.jwplatform.com/thumbs/M2dlgvO3-1280.jpg"
            />
            <meta
              itemProp="contentUrl"
              content="https://content.jwplatform.com/videos/M2dlgvO3-Mjco38KE.mp4"
            />
            <div
              style={{
                position: 'relative',
                overflow: 'hidden',
                paddingBottom: '56.25%'
              }}
            >
              {' '}
              <iframe
                src="https://cdn.jwplayer.com/players/M2dlgvO3-zRvZORUl.html"
                width="100%"
                height="100%"
                frameBorder="0"
                scrolling="auto"
                title="La resurrección de los bofedales que necesita Lima"
                style={{ position: 'absolute' }}
                allowFullScreen
              ></iframe>{' '}
            </div>
          </div>
      </div>
    </div>
  )
}

export default Informe1
